import type { Region } from '~/types/global.types'

export const RegionSlugById: { [key: number]: string } = {
    0: 'all',
    1: 'south',
    2: 'north-west',
    3: 'privolzsky',
    4: 'central',
    5: 'east',
    6: 'ural',
    7: 'sng',
} as const

export interface MapRegion extends Region {
    count_portfolios: number
}
